import React from 'react';
import {
  toast,
} from 'react-toastify';

import {
  Button,
  Dropdown,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

type Action = {
  name: string,
};

type Props = {
  name: string,
  actions: Array<Action>,
  readOnly: boolean,
  canSchedule: boolean,
  onSaveName: { (name: string): void },
  onEnter: { (): void },
};

const WorkoutExercisesHeader = ({
  name,
  actions,
  readOnly,
  canSchedule,
  onSaveName,
  onEnter,
}: Props) => (
  <S.Header>
    <Flex fillSpace spacing={10}>
      {readOnly ? (
        <S.Title>
          {name}
        </S.Title>
      ) : (
        <S.TitleInput
          defaultValue={name}
          onSave={onSaveName}
          onSaveEnter={onSaveName}
        />
      )}
    </Flex>
    {canSchedule && (
      <Flex spacing={10}>
        <Button
          ghost
          appearance="primaryReverse"
          onClick={onEnter}
        >
          Enter Results
        </Button>
        <Button
          ghost
          appearance="primaryReverse"
          onClick={() => toast.warning('Currently this feature is only available on mobile')}
        >
          Schedule
        </Button>
      </Flex>
    )}

    {!readOnly && (
      <Flex>
        <Dropdown
          trigger={(
            <S.Actions />
          )}
          items={actions}
        />
      </Flex>
    )}
  </S.Header>
);

export default WorkoutExercisesHeader;
